import { defineMessage } from 'services/localization';

export const messages = {
    description: defineMessage('please_see_below_line_i_for_budgetperiod_period'),
    popupTitle: defineMessage('budget_check_for_budgetname_budget_1'),
    totalBudgetImpact: defineMessage('total_budget_impact'),
    warningOfExceed: defineMessage('please_note_that_with_t_ined_period_is_exceeded'),
    overbudgetText: defineMessage('please_note_that_with_t_ined_period_is_exceeded_1'),
};
